import { useCallback, useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'

import classNames from 'classnames'
import { connect } from 'react-redux'
import { Onlineshow } from '@dmi-mch/services'
import { logger, validateAxiosResponse } from '@dmi-mch/utils'
// import { LoginContext } from '@providers/Login'

import { updateCountdown } from '@utils'
import { Gallery as GalleriesService, Events as EventService, http } from '@services'
import cssClasses from '@constants/cssClasses'
import { useInterval } from '@hooks'
import Styles from './styles'
// import Module from './Module'

const OnlineShowRoom = ({
  pageMetaInfo,
  grcpm_related_online_show,
  grcpm_auto_detect_gallery,
  grcpm_related_gallery,
  // roomPreviewtitle,
  arcpm_related_artist,
  arcpm_auto_detect_artist,
  ...props
}) => {
  // props
  const autoDetect = grcpm_auto_detect_gallery === 'true'
  const galleryId = autoDetect ? pageMetaInfo.id : grcpm_related_gallery
  const displayCountdown = ['UPCOMING', 'OPEN_FOR_VIP', 'OPEN_FOR_EVERYONE', 'SPECIAL_ROOM_OPEN_FOR_EVERYONE']
  // const { showLogin, isUserLogged } = useContext(LoginContext)

  // states
  const [moduleLoaded, setModuleLoaded] = useState(false)
  const [show, setShow] = useState({ rooms: null, galleryData: null })
  const onlineshowService = useRef(new Onlineshow({ http }))

  // fetch rooms based on the show selected in the CMS module
  const fetchRoom = useCallback(async () => {
    let showRoomData = { rooms: null, galleryData: null }
    let roomReq = null

    try {
      let ownedOrCollaboratedAccountIds = null
      if (autoDetect) {
        ownedOrCollaboratedAccountIds = pageMetaInfo.accountId
      } else {
        if (galleryId) {
          const galleryResponse = await GalleriesService.getGalleryById(galleryId)
          if (validateAxiosResponse(galleryResponse)) {
            //@ts-ignore
            ownedOrCollaboratedAccountIds = galleryResponse.data.accountId
            //@ts-ignore
            showRoomData.galleryData = galleryResponse.data
          }
        }
      }

      const params = {
        orderBy: 'rpriority',
        isFutureEvent: true,
        includeFilters: false,
        exhibition: true,
        online: true,
        incomplete: false,
        onlineShowId: grcpm_related_online_show,
        limit: 99
      }

      if (pageMetaInfo.type === 'artistDetailPage') {
        const artistId = arcpm_auto_detect_artist === 'false' ? arcpm_related_artist || pageMetaInfo.id : pageMetaInfo.id
        //@ts-ignore
        params.withArtworksFromArtistId = artistId
      }
      if (ownedOrCollaboratedAccountIds) {
        //@ts-ignore
        params.ownedOrCollaboratedAccountIds = ownedOrCollaboratedAccountIds
      }
      //@ts-ignore
      roomReq = await EventService.getUpcomingEvents(params)
      //@ts-ignore
      if (validateAxiosResponse(roomReq) && 'items' in roomReq.data.events) {
        //@ts-ignore
        showRoomData.rooms = roomReq.data.events.items
      }
    } catch (e) {
      logger(e)
    }
    return showRoomData
  }, [autoDetect, galleryId, grcpm_related_online_show, pageMetaInfo, arcpm_auto_detect_artist, arcpm_related_artist])

  // fetch show based on the one selected in the CMS module
  const fetchShow = useCallback(
    async (didUnmount = false) => {
      try {
        let req = null
        let showRoomData = {}
        // fetch the show data
        req = await onlineshowService.current.getOnlineShowViews(grcpm_related_online_show)
        if (validateAxiosResponse(req)) {
          // clones the show data into a new object
          //@ts-ignore
          showRoomData = { ...req.data }
          const reqData = await fetchRoom()
          //@ts-ignore
          if (reqData.rooms && reqData.rooms.length > 0) {
            // appends rooms and gallery data to this object
            //@ts-ignore
            showRoomData.rooms = reqData.rooms
            //@ts-ignore
            showRoomData.galleryData = reqData.galleryData
            // mock the dates for the client side countdown
            //@ts-ignore
            showRoomData.mockSecondsToVisibleDate = showRoomData.secondsToVisibleDate
            //@ts-ignore
            if (showRoomData.secondsToPublicStartDate) {
              //@ts-ignore
              showRoomData.mockSecondsToPublicStartDate = showRoomData.secondsToPublicStartDate
            }
            //@ts-ignore
            if (showRoomData.secondsToVipStartDate) {
              //@ts-ignore
              showRoomData.mockSecondsToVipStartDate = showRoomData.secondsToVipStartDate
            }
            //@ts-ignore
            if (showRoomData.secondsToSpecialRoomStartDate) {
              //@ts-ignore
              showRoomData.mockSecondsToSpecialRoomStartDate = showRoomData.secondsToSpecialRoomStartDate
            }
            //@ts-ignore
            showRoomData.mockSecondsToEndDate = showRoomData.secondsToEndDate
            //@ts-ignore
            showRoomData.isMockCounterActive = false
            if (!didUnmount) {
              setModuleLoaded(true)
              //@ts-ignore
              setShow(showRoomData)
            }
          }
        }
      } catch (e) {
        setModuleLoaded(true)
        logger(e)
      }
    },
    [fetchRoom, grcpm_related_online_show]
  )

  // actions
  // const onLogin = useCallback(async () => {
  //   await fetchShow()
  // }, [fetchShow])


  // const onClickLogin = useCallback((event) => {
  //   event.preventDefault()
  //   showLogin({
  //     onLoginSuccessCallback: () => { onLogin() }
  //   })
  // }, [onLogin, showLogin])

  useInterval(() => {
    //@ts-ignore
    show && displayCountdown.includes(show.currentPhase) && updateCountdown(show, fetchShow, setShow)
  }, 30000)

  useEffect(() => {
    let didUnmount = false
    !moduleLoaded && fetchShow(didUnmount)
    return () => {
      didUnmount = true
    }
  }, [fetchShow, moduleLoaded])

  //@ts-ignore
  if (show.rooms && show.rooms.length > 0 && displayCountdown.includes(show.currentPhase)) {
    return (
      <>
        OSROOM UIKIT MIgration
        <Styles
          // @ts-ignore
          id={props.id}
          className={classNames('otm-preview-room', `preview-${props.id}`, props.className, cssClasses.CMS_MODULE)}
        >
          {/* <Module
            grcpm_title={roomPreviewtitle || props.grcpm_title}
            onClickLogin={onClickLogin}
            show={show}
            pageMetaInfo={pageMetaInfo}
            isLogged={isUserLogged}
            id={arcpm_related_artist || props.id}
          /> */}
        </Styles>
      </>
    )
  }

  return null
}

OnlineShowRoom.propTypes = {
  pageMetaInfo: PropTypes.object,
  id: PropTypes.number,
  className: PropTypes.string,
  grcpm_title: PropTypes.string,
  grcpm_auto_detect_gallery: PropTypes.string,
  grcpm_related_gallery: PropTypes.string,
  grcpm_call_to_action_label: PropTypes.string,
  grcpm_call_to_action_link: PropTypes.string,
  grcpm_related_online_show: PropTypes.string,
  arcpm_related_artist: PropTypes.string,
  arcpm_auto_detect_artist: PropTypes.string,
  user: PropTypes.object,
  openGraphData: PropTypes.object,
  labels: PropTypes.object,
  roomPreviewtitle: PropTypes.string
}

export default connect(({ user, shared }) => ({ user, labels: shared.labels }), null)(OnlineShowRoom)
